module.exports = __webpack_public_path__ + "media/project_quote/trash-ico-b4f89d6e.svg";